import React, {useState,useEffect,useContext,useRef} from "react";
import { useLocation,useNavigate } from 'react-router-dom'
import Lang from '../lang/translations';
import Auth from '../../userServices/authServices';
import Context from '../context/context';
import ReactGA from 'react-ga4';
import helpersFunction from "../_helpers/helpersFunction";
import { useGoogleLogin } from '@react-oauth/google';
const config = require("../_helpers/configServizi");

// Login Facebook e Apple: codice pronto ma non ancora attivo (manca la configurazione su Facebook/Apple) -> true per mostrarli
const LOGIN_FACEBOOK_APPLE_ATTIVO = false;

export default function Signup(props) {
    const  context = useContext(Context)

	const [errore, setErrore] = useState("");
	const [spinner, setSpinner] = useState(false);
	
	const [tipoForm, setTipoForm] = useState(context.tipoForm ? context.tipoForm : "registrazione");

	const [regioni, setRegioni] = useState({});
	const [formError, setFormError] = useState({email:false,password:false,geo:false});

	const [form_email, setForm_email] = useState('');
	const [form_password, setForm_password] = useState('');
	const [form_region, setForm_region] = useState('');


    const suggerimento_citta = Lang( {"w": "suggerimento_citta","page": "signupForm"} )

	var location = useLocation();
	location = location.pathname.split("/")

	const navigate = useNavigate();


	function validateEmail(email){
		const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return re.test(email);
	};

	function checkErrori(){
		if(form_email.length == 0){
			setFormError({...formError,email:true})
			setErrore(Lang( {"w": "errore_email","page": "signupForm"} ));
			return true
		} 
		if(!validateEmail(form_email)){
			setFormError({...formError,email:true})
			setErrore(Lang( {"w": "errore_email","page": "signupForm"} ));
			return true
		} 
		if(form_password.length == 0){
			setFormError({...formError,password:true})
			setErrore(Lang( {"w": "errore_password","page": "signupForm"} ));
			return true
		}
		if(form_region.length == 0){
			setFormError({...formError,geo:true})
			setErrore(Lang( {"w": "errore_citta","page": "signupForm"} ));
			return true
		}
	}
	
    const onSubmit = (e) => {

		e.preventDefault();
		var data = {}
		

		try{

			if(checkErrori()){
				setSpinner(false);
				return
			}

			setSpinner(true);
			setErrore("");

			const domain = window.location.hostname;
	

			data.source = localStorage.getItem('source') ? localStorage.getItem('source') : null
			data.country = localStorage.getItem('country') ? localStorage.getItem('country') : helpersFunction.getCountry()
			data.campid = localStorage.getItem('campid') ? localStorage.getItem('campid') : ""
			data.region = form_region
			data.email =  form_email.replace(/\s+/g, '');
			data.password = form_password;
			data.ip = localStorage.getItem('ip') ? localStorage.getItem('ip') : null;
			data.clickid=localStorage.getItem('trackerId') ? localStorage.getItem('trackerId') : Math.random().toString(36).slice(2);
			data.fingerprint = localStorage.getItem('fingerprint') ? localStorage.getItem('fingerprint') : null
			data.fluxId = context.fluxId ? context.fluxId: config.servizi[domain].default_fluxid
			data.servizio =  window.location.hostname;
			data.ua =  navigator.userAgent;
			data.sono = "uomo"
			data.cerco = "donna"

			Auth.register(data,context)
			.then(res => {

				if(res.token){
					
					helpersFunction.setUser(res,context,true,true)
					helpersFunction.setAnalyticsDimensions(data.clickid,data.source,data.country,data.fluxId,true)
					helpersFunction.GetNavigation(data.clickid,context)

					navigate("/")

					if(res.flusso.optin == "doi"){
						helpersFunction.showPopuphook("doi",context,res)
						
						return;
					}

					if(res.regalo_messaggi){

						var contenuto = {}
						contenuto.title = Lang( {"w": "bentornato","page": "popupGenerico"} )
						contenuto.descrizione = Lang( {"w": "regalo_messaggi","page": "popupGenerico"} )
						contenuto.bottoni = [
							{testo:Lang( {"w": "chiudi","page": "popupGenerico"}),icona:"fa fa-window-close" }
						]
						
						setTimeout(()=>{
							helpersFunction.showPopupgenerico("regalo_messaggi",context,contenuto)
						},500)
					}
				}else{
				
					setErrore(helpersFunction.errorCodes(res));
					setSpinner(false); 
				}

			}).catch((err)=>{
				helpersFunction.logToBackend("problemi su signup",{err:err.message,clickid:localStorage.getItem('trackerId')});
				setSpinner(false);
			})
		}catch(err){
			//helpersFunction.logToBackend("problemi su signup try catch",{err:err.message,clickid:localStorage.getItem('trackerId')})
			console.log(err)
			setSpinner(false)
		}
	};

	const googleLogin = useGoogleLogin({
		flow: 'auth-code',
		onSuccess: async (codeResponse) => {

			const domain = window.location.hostname;

			var data = {}
			
			data.source = localStorage.getItem('source') ? localStorage.getItem('source') : null
			data.country = localStorage.getItem('country') ? localStorage.getItem('country') : helpersFunction.getCountry()
			data.campid = localStorage.getItem('campid') ? localStorage.getItem('campid') : ""
			data.ip = localStorage.getItem('ip') ? localStorage.getItem('ip') : null;
			data.clickid=localStorage.getItem('trackerId') ? localStorage.getItem('trackerId') : Math.random().toString(36).slice(2);
			data.fingerprint = localStorage.getItem('fingerprint') ? localStorage.getItem('fingerprint') : null
			data.fluxId = context.fluxId ? context.fluxId:  config.servizi[domain].default_fluxid
			data.servizio =  window.location.hostname;
			data.ua =  localStorage.getItem('ua') ? localStorage.getItem('ua') : null;
			data.code = codeResponse.code
			data.sono = "uomo"
			data.cerco = "donna"
			
			const res = await Auth.LP_authWithGoogle(data)
	
			if(res.token){
	
				//---- setto il token per fare fare la chiamata di update città 
				localStorage.setItem('token', res.token);
				localStorage.setItem('trackerId', res.clickid);

				// inseriamo il check per il DOI (conferma della email per accesso/registrazione)
				if(res.flusso?.optin === "doi" && res.confirmed_email === false) {
					helpersFunction.showPopuphook("doi", context, res);	// helpers in login.js, helpersFunction in formClassica.js
					return;
				}

				if(!res.login){
					context.setPopupHook({ ...context.popupHook, provenienza:"impostaRegione"})
					return
				}else{
					helpersFunction.setUser(res,context,true,false)
					helpersFunction.setAnalyticsDimensions(data.clickid,data.source,data.country,data.fluxId,true)
					helpersFunction.GetNavigation(data.clickid,context)
					
					if(res.regalo_messaggi){
				
						var contenuto = {}
						contenuto.title = Lang( {"w": "bentornato","page": "popupGenerico"} )
						contenuto.descrizione = Lang( {"w": "regalo_messaggi","page": "popupGenerico"} )
						contenuto.bottoni = [
							{testo:Lang( {"w": "chiudi","page": "popupGenerico"}),icona:"fa fa-window-close" }
						]
					
						
						setTimeout(()=>{
							helpersFunction.showPopupgenerico("regalo_messaggi",context,contenuto)
						},500)
					}   

					context.processoDiNotifica();
	
					helpersFunction.GetNavigation(res.clickid,context);
					navigate("/");
					props.onHide();
				}

			}else{
				setErrore(helpersFunction.errorCodes(res));
				setSpinner(false); 
			}
		},
		onError: errorResponse => console.log(errorResponse),
	});

	const loginWithFacebook = () => {
		window.FB.login((response) => {
			if(response.authResponse) {
				handleFacebookAuth(response.authResponse.accessToken);
			}
		}, {scope: 'email, public_profile'})
	}

	// FUnzione login via facebook da chiamare quando clickiamo il bottone "login con Facebook"
	const handleFacebookAuth = async (accessToken) => {
		const domain = window.location.hostname
		var data = {}
		data.source      = localStorage.getItem('source') || null
		data.country     = localStorage.getItem('country') || helpersFunction.getCountry()
		data.campid      = localStorage.getItem('campid') || ""
		data.ip          = localStorage.getItem('ip') || null
		data.clickid     = localStorage.getItem('trackerId') || Math.random().toString(36).slice(2)
		data.fingerprint = localStorage.getItem('fingerprint') || null
		data.fluxId      = context.fluxId || config.servizi[domain].default_fluxid
		data.servizio    = window.location.hostname
		data.ua          = localStorage.getItem('ua') || null
		data.sono        = "uomo"
		data.cerco       = "donna"
		data.access_token = accessToken

		const res = await Auth.LP_authWithFacebook(data)

		if (res.needsRegistration) {
			if (res.prefill?.email) setForm_email(res.prefill.email)
			return
		}
		if (res.token) {
			localStorage.setItem('token', res.token);
			localStorage.setItem('trackerId', res.clickid);

			// inseriamo il check per il DOI (conferma della email per accesso/registrazione)
			if(res.flusso?.optin === "doi" && res.confirmed_email === false) {
				helpersFunction.showPopuphook("doi", context, res);	// helpers in login.js, helpersFunction in formClassica.js
				return;
			}

			if (!res.login) {
				context.setPopupHook({ ...context.popupHook, provenienza: "impostaRegione" })
			} else {
				helpersFunction.setUser(res, context, true, false)
				helpersFunction.setAnalyticsDimensions(data.clickid, data.source, data.country, data.fluxId, true)
				helpersFunction.GetNavigation(res.clickid, context)
				navigate("/")
				props.onHide()
			}
		} else {
			setErrore(helpersFunction.errorCodes(res))
			setSpinner(false)
		}
	}


	// ================================= APPLE Handlers ====================================
	const loginWithApple = async () => {
		if(!window.AppleID) {
			setErrore("Apple login non disponibile. Riprova a breve");
			return;
		}
		try {
			const response = await window.AppleID.auth.signIn();
			const id_token = response?.authorization?.id_token;
			if (!id_token) return;
			await handleAppleAuth(id_token, response.user || null);
		} catch (e) {
			console.log("[Apple] login annullato/errore:", e?.error || e?.message || e);
		}
	};

	const handleAppleAuth = async (id_token, appleUser) => {
		const domain = window.location.hostname;
		var data = {};
		data.source      = localStorage.getItem('source') || null;
		data.country     = localStorage.getItem('country') || helpersFunction.getCountry();
		data.campid      = localStorage.getItem('campid') || "";
		data.ip          = localStorage.getItem('ip') || null;
		data.clickid     = localStorage.getItem('trackerId') || Math.random().toString(36).slice(2);
		data.fingerprint = localStorage.getItem('fingerprint') || null;
		data.fluxId      = context.fluxId || config.servizi[domain].default_fluxid;
		data.servizio    = window.location.hostname;
		data.ua          = localStorage.getItem('ua') || null;
		data.sono        = "uomo";   // come Google/Facebook LP
		data.cerco       = "donna";
		data.id_token    = id_token;
		data.user        = appleUser;

		const res = await Auth.LP_authWithApple(data);
		if(res.token) {
			localStorage.setItem('token', res.token);
			localStorage.setItem('trackerId', res.clickid);

			// inseriamo il check per il DOI (conferma della email per accesso/registrazione)
			if(res.flusso?.optin === "doi" && res.confirmed_email === false) {
				helpersFunction.showPopuphook("doi", context, res);	// helpers in login.js, helpersFunction in formClassica.js
				return;
			}

			if (!res.login) {
				context.setPopupHook({ ...context.popupHook, provenienza: "impostaRegione" });
				context.setModalShowHook(true);
				return;
			} else {
				helpersFunction.setUser(res, context, true, false);
				helpersFunction.setAnalyticsDimensions(data.clickid, data.source, data.country, data.fluxId, true);
				helpersFunction.GetNavigation(res.clickid, context);
				navigate("/");
				props.onHide();
			}
		} else {
			setErrore(helpersFunction.errorCodes(res));
			setSpinner(false);
    }
	}





    useEffect(() => { 

        //form registrazione
        setTipoForm("registrazione");
		
		helpersFunction.getRegionsByCountry()
            .then(res => {
                setRegioni(res)
            })
	
	},[]);


    function Spinner(){
		if(spinner){
			return (<div className="spinner-border text-light" role="status">
		  <span className="sr-only"><Lang w={"caricando"} page={"signupForm"}/></span>
		</div>);
		}else{
			return (<div></div>);
		}
	}




	
    function handleInputChange(target) {
		const value = target.currentTarget.value;
		
		if (target.currentTarget.name === "email") {
			
			setForm_email(target.currentTarget.value)

			if (!validateEmail(value)) {
				 setFormError({...formError,email:true}) 
			}else{
				setFormError({...formError,email:false}) 
			}
			
		}

		if (target.currentTarget.name === "password") {
			if(value.length > 0){
				setFormError({...formError,password:false}) 
				setForm_password(target.currentTarget.value)
			}else{
				setFormError({...formError,password:true})
			} 
		}

		if (target.currentTarget.name === "geo") {
			if(value.length > 0) {
				setFormError({...formError,geo:false})
				setForm_region(target.currentTarget.value)
			}else{
				setFormError({...formError,geo:true})
			}
		}
	}

    return (
        <div> <h3><Lang w={"inizio_divertimento"} page={"popupHook"}/></h3>
        <h4><Lang w={"ti_invieremo"} page={"popupHook"}/></h4>
		<h5><Lang w={"se_non_trovi"} page={"popupHook"}/></h5>
            <form className={"formSignup"} onSubmit={onSubmit}>
                <input type="email" name="email" value={form_email} placeholder={ Lang( {"w": "email","page": "signupForm","var":true} )} className={formError.email && ("errorCardInput")}  onChange={(e) => handleInputChange(e)}></input>
                <input type="password" name="password"  placeholder={Lang( {"w": "scegli_una_password","page": "signupForm","var":true} )} className={formError.password && ("errorCardInput")}  onChange={(e) => handleInputChange(e)}></input>
				<label for="geo">{Lang( {"w": "regione","page": "signupForm","var":true} )}</label>
                <select  name="geo" onChange={(e) => handleInputChange(e)} className={formError.geo && ("errorCardInput")}>
					<option selected disabled hidden value="">{Lang( {"w": "regione","page": "signupForm","var":true} )}*</option>
                    { regioni.length > 0 && 
                        (
                            regioni.map(el=>(
                               <option value={el}>{el}</option>
                                
                            ))
                        ) 
                    }
                </select>
			     
		{errore && (<p className='erroreSignup'>{errore}</p>)}

                <Spinner/>
                <input type="submit" value={Lang( {"w": "registrati_gratis","page": "signupForm","var":true} )} disabled={spinner}></input>
				<div className="signupGoogleContainer">
					<h5 className="orsignwithgoogle">O</h5>
					
					<button type="button" className="signwithsocial signwithsocial--google" onClick={() => googleLogin()}>
						<i className="fab fa-brands fa-google"></i>Sign in with Google
					</button>
					
					{LOGIN_FACEBOOK_APPLE_ATTIVO && <>
					<button type="button" className="signwithsocial signwithsocial--facebook" onClick={loginWithFacebook}>
						<i className="fab fa-facebook-f"></i>Sign in with Facebook
					</button>
					<button type="button" className="signwithsocial signwithsocial--apple" onClick={loginWithApple}>
						<i className="fab fa-apple"></i> Sign in with Apple
					</button>
					</>}
              	</div>
				
                
            </form></div>
    )
	
}